import { Subscription } from 'rxjs';

import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';

import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'apm-checkbox-type',
  templateUrl: './checkbox-type.component.html',
  styleUrls: ['./checkbox-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckboxTypeComponent extends FieldType<FieldTypeConfig> implements OnDestroy {
  private formSubscription: Subscription | undefined;

  get customProps() {
    return this.props['custom'] ?? {};
  }

  ngOnDestroy() {
    this.formSubscription?.unsubscribe();
  }
}
